var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailDocIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 14.125H21.75C20.8525 14.125 20.125 14.8525 20.125 15.75V35.25C20.125 36.1475 20.8525 36.875 21.75 36.875H34.75C35.6475 36.875 36.375 36.1475 36.375 35.25V15.75C36.375 14.8525 35.6475 14.125 34.75 14.125Z",
    fill: "#1066B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 14.125H21.75C20.8525 14.125 20.125 14.8525 20.125 15.75V35.25C20.125 36.1475 20.8525 36.875 21.75 36.875H34.75C35.6475 36.875 36.375 36.1475 36.375 35.25V15.75C36.375 14.8525 35.6475 14.125 34.75 14.125Z",
    fill: "url(#paint0_linear_2101_21776)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 24.6875H20.125V32.8125H28.25V24.6875Z",
    fill: "#167EB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.375 24.6875H28.25V32.8125H36.375V24.6875Z",
    fill: "#32A9E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2101_21776",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 23,
    width: 20,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.875H36.375C37.2725 23.875 38 24.6025 38 25.5V35.25C38 36.1475 37.2725 36.875 36.375 36.875H20.125C19.2275 36.875 18.5 36.1475 18.5 35.25V23.875Z",
    fill: "url(#paint1_linear_2101_21776)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2101_21776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 23.5V26.5H18V23.5H21Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 23.875V27.125H36.375V23.875H38Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 36.875V25.5L17.6875 36.875H38Z",
    fill: "url(#paint2_linear_2101_21776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36.875V25.5L38.8125 36.875H18.5Z",
    fill: "url(#paint3_linear_2101_21776)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2101_21776",
    x1: 20.125,
    y1: 25.5,
    x2: 36.375,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2101_21776",
    x1: 18.5,
    y1: 34.25,
    x2: 38,
    y2: 34.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2101_21776",
    x1: 38,
    y1: 31.1875,
    x2: 18.5,
    y2: 31.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2101_21776",
    x1: 18.5,
    y1: 31.1875,
    x2: 38,
    y2: 31.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDocIcon);
export default __webpack_public_path__ + "static/media/emailDocIcon.d566324b53d42ee84bf79bf4173d9d73.svg";
export { ForwardRef as ReactComponent };